<template>
  <div class="login-wrap">
    <Card class="login">
      <h1>登录</h1>
      <Form
        label-position="left"
        @keyup.enter.native="submit"
      >
        <FormItem>
          <iInput
            v-model="userName"
            type="text"
            size="large"
            placeholder="用户名"
            autofocus
          >
            <Icon
              slot="prepend"
              type="md-person"
              size="20"
            />
          </iInput>
        </FormItem>
        <FormItem>
          <iInput
            v-model="password"
            type="password"
            size="large"
            placeholder="密码"
          >
            <Icon
              slot="prepend"
              type="md-lock"
              size="20"
            />
          </iInput>
        </FormItem>
        <Button
          type="primary"
          size="large"
          long
          @click="submit"
        >
          登录
        </Button>
      </Form>
    </Card>
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import { Card, Form, FormItem, Input, Button, Icon } from 'iview'

export default {
  components: {
    Card,
    Form,
    FormItem,
    iInput: Input,
    Button,
    Icon
  },

  data () {
    return {
      userName: '',
      password: ''
    }
  },

  created () {
    this.clearToken()
  },

  methods: {
    ...mapMutations([
      'setUserName'
    ]),

    submit () {
      axios.post('/login', {
        user_name: this.userName,
        password: this.password
      }).then(result => {
        if (result.code === -1) {
          this.$Message.error(result.message)
        } else {
          this.setToken(result.data.token, result.data.expire, this.userName)
          this.setUserName({
            userName: this.userName
          })
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-wrap {
  width: 100vw;
  height: 100vh;
  background-color: #f8f8f9;

  .login {
    position: absolute;
    left: 50%;
    top: 40%;
    width: 400px;
    background-color: #fff;
    transform: translate(-50%, -50%);

    h1 {
      margin-bottom: 15px;
    }

    form {
      padding-bottom: 15px;
    }
  }
}
</style>
